export default __webpack_public_path__ + "60d6f426fe4bfd41b1edba7132d33605.jpg";